import axios from "@/api/axios";

export default {
  // Get all categories

  getCategories(params = {}) {
    return axios.get("/categories", { params });
  },

  // Get single category
  getCategory(id) {
    return axios.get(`/categories/${id}`);
  },

  // Create category
  createCategory(data) {
    return axios.post("/categories", data);
  },

  // Update category
  updateCategory(id, data) {
    return axios.put(`/categories/${id}`, data);
  },

  // Delete category
  deleteCategory(id) {
    return axios.delete(`/categories/${id}`);
  },

  // By brand
  getCategoriesByBrand(brandId) {
    return axios.get(`/brands/${brandId}/categories`);
  },
};
